import {
  GOOGLE_SPREADSHEET_MIME_TYPE,
} from "./googleDriveConfig.js";

const PICKER_SCRIPT_ID = "google-picker-api-script";
const PICKER_SCRIPT_SRC = "https://apis.google.com/js/api.js";

let pickerLoadPromise = null;

const injectScript = (src, scriptId) =>
  new Promise((resolve, reject) => {
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      if (window.gapi) {
        resolve();
        return;
      }
      existingScript.addEventListener("load", resolve, { once: true });
      existingScript.addEventListener(
        "error",
        () => reject(new Error("Failed to load Google Picker script")),
        { once: true }
      );
      return;
    }

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = src;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () =>
      reject(new Error("Failed to load Google Picker script"));
    document.body.appendChild(script);
  });

export const loadGooglePickerApi = async () => {
  if (typeof window === "undefined") {
    throw new Error("Google Picker is only available in the browser");
  }

  if (window.google?.picker) {
    return window.google.picker;
  }

  if (!pickerLoadPromise) {
    pickerLoadPromise = injectScript(PICKER_SCRIPT_SRC, PICKER_SCRIPT_ID)
      .then(
        () =>
          new Promise((resolve, reject) => {
            if (!window.gapi?.load) {
              reject(new Error("Google API loader did not initialize"));
              return;
            }

            window.gapi.load("picker", {
              callback: () => {
                if (!window.google?.picker) {
                  reject(new Error("Google Picker did not initialize"));
                  return;
                }
                resolve(window.google.picker);
              },
              onerror: () =>
                reject(new Error("Google Picker library failed to load")),
            });
          })
      )
      .catch((error) => {
        pickerLoadPromise = null;
        throw error;
      });
  }

  return pickerLoadPromise;
};

export const showSpreadsheetPicker = async ({
  developerKey,
  appId,
  oauthToken,
  callback,
}) => {
  const picker = await loadGooglePickerApi();
  const spreadsheetsView = new picker.DocsView(picker.ViewId.SPREADSHEETS)
    .setMode(picker.DocsViewMode.LIST)
    .setMimeTypes(GOOGLE_SPREADSHEET_MIME_TYPE);

  const pickerInstance = new picker.PickerBuilder()
    .addView(spreadsheetsView)
    .enableFeature(picker.Feature.NAV_HIDDEN)
    .setOAuthToken(oauthToken)
    .setDeveloperKey(developerKey)
    .setAppId(appId)
    .setCallback(callback)
    .build();

  pickerInstance.setVisible(true);
  return pickerInstance;
};
